export const environment = {
    production: false,
    apiUrl: 'https://api-staging-app.unieon.id/api',
    uploadsUrl: 'https://api-staging.unieon.id/uploads',
    appName: 'PT KAI IT Asset Stock Opname',
    version: '1.0.0',
};
